import { render, staticRenderFns } from "./ServicesBlock.vue?vue&type=template&id=1c590978&scoped=true&"
import script from "./ServicesBlock.vue?vue&type=script&lang=js&"
export * from "./ServicesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ServicesBlock.vue?vue&type=style&index=0&id=1c590978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c590978",
  null
  
)

export default component.exports